
export const ASSIGN_RESOURCES_TO_TASKS = 'ASSIGN_RESOURCES_TO_TASKS';
export const SELECTED_TASKS_AVAILABLE = 'SELECTED_TASKS_AVAILABLE';

export function selectTasksSuccess(selectedTasks) {
  return {
    type: SELECTED_TASKS_AVAILABLE,
    selectedTasks,
  };
}

export function assignResourcesToTasks(tasks, stages) {
  return {
    type: ASSIGN_RESOURCES_TO_TASKS,
    stages,
    tasks,
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/tasks.js